import { Skeleton, type SkeletonProps } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import type { SxProps } from "@mui/system";
import React from "react";

const cardSkeletonSx: SxProps<Theme> = {
  backgroundColor: "#eef2f7",
  borderRadius: 999,
  "&::after": {
    background:
      "/* @noflip */ linear-gradient(100deg, rgba(255, 255, 255, 0) 12%, rgba(255, 255, 255, 0.78) 50%, rgba(255, 255, 255, 0) 88%)",
  },
};

const blueCardSkeletonSx: SxProps<Theme> = {
  ...cardSkeletonSx,
  // Matches MUI's pre-existing light-mode Skeleton surface.
  backgroundColor: "rgba(1, 22, 56, 0.11)",
};

type CardSkeletonProps = Omit<SkeletonProps, "animation" | "variant"> & {
  tone?: "default" | "blueCard";
};

/** Shared rounded, diffuse loading placeholder for cards and section hints. */
export const CardSkeleton: React.FC<CardSkeletonProps> = ({ tone = "default", sx, ...props }) => {
  const baseSx = tone === "blueCard" ? blueCardSkeletonSx : cardSkeletonSx;
  const resolvedSx: SxProps<Theme> = sx === undefined ? baseSx : ([baseSx, sx] as SxProps<Theme>);

  return <Skeleton {...props} animation="wave" variant="rounded" sx={resolvedSx} />;
};
